export const reduxKey = 'flags';
export const actionKey = '@@flags';

//# sourceMappingURL=constants.js.map